import { createAction } from '@reduxjs/toolkit';

import { createActionWithCallback } from 'core/store/utils';
import { LanguageInfo, RequestError } from 'types';

import { State } from './types';

export const fetchTranslationLanguages = createActionWithCallback<LanguageInfo[], Error>()(
  'translation-languages/fetch'
);

export const fetchedTranslationLanguages = createAction(
  'translation-languages/fetched',
  (data?: State['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default { fetchTranslationLanguages, fetchedTranslationLanguages };
